/**
 * Escapes any reserved characters in a string so that its characters are used
 * as literals in a regular expression.
 */
export const escapeRegExp = (str: string) => {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
}
